module.exports = __webpack_public_path__ + "static/media/coupon_icon.61122a86.svg";